import { ClaudeIcon } from '@/assets/icons/claude';
import { CursorIcon } from '@/assets/icons/cursor';
import { DevinIcon } from '@/assets/icons/devin';
import { OpenAiIcon } from '@/assets/icons/openai';
import type { CodingAgentId } from '@/features/electron-api/features/CodingAgentsAPI';
import { cn } from '@/lib/utils';

const LOGOS = {
  'claude-code': { Icon: ClaudeIcon, className: 'text-[#D97757]' },
  codex: { Icon: OpenAiIcon, className: 'text-foreground' },
  cursor: { Icon: CursorIcon, className: 'text-foreground' },
  devin: { Icon: DevinIcon, className: 'text-foreground' },
} as const satisfies Record<
  CodingAgentId,
  { Icon: typeof ClaudeIcon; className: string }
>;

export const AgentLogo = ({
  id,
  className,
}: {
  id: CodingAgentId;
  className?: string;
}) => {
  const { Icon, className: colour } = LOGOS[id];
  return <Icon className={cn(colour, className)} />;
};
